import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import BottomNav from './components/BottomNav';
import LoadingSpinner from './components/LoadingSpinner';
import LoginPage from './pages/LoginPage';
import TodayPage from './pages/TodayPage';
import WeekPage from './pages/WeekPage';
import EventDetailPage from './pages/EventDetailPage';
import GroupPage from './pages/GroupPage';
import ProfilePage from './pages/ProfilePage';

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <div className="min-h-screen pb-20">
      <Routes>
        <Route path="/" element={<TodayPage />} />
        <Route path="/week" element={<WeekPage />} />
        <Route path="/event/:id" element={<EventDetailPage />} />
        <Route path="/group" element={<GroupPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <BottomNav />
    </div>
  );
}
